<template>
    <div class="container-fluid">
        <div class="row no-gutter">
            <div class="col-lg-3 bg-image"></div>
            <div class="col-lg-9">
                <div class="login d-flex align-items-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 mx-auto">
                                <div class="mb-8 text-center">
                                    <img class="img-fluid" src="/client/images/logo-login.png" />
                                </div>

                                <div class="card rounded-lg shadow-sm bg-light-gray">
                                    <div class="card-header px-lg-7 px-4 pt-3 pb-0 border-0 bg-transparent">
                                        <div class="row d-flex justify-content-center">
                                            <div class="col pt-4 mb-2"><h5>Password recovery</h5></div>
                                        </div>
                                    </div>
                                    <div class="card-block px-lg-7 px-4 pb-6">
                                        <p class="lead text-muted mb-4 mr-3">
                                            Enter your email, which you used for registration to recover your password
                                            or please contact us if you require any assistance
                                        </p>
                                        <div class="input-group mb-5">
                                            <input
                                                class="form-control rounded mx-0 mr-2"
                                                type="text"
                                                placeholder="Enter your email"
                                                v-model="email"
                                            />
                                            <button class="btn btn-primary" v-on:click="reset">
                                                Submit information
                                            </button>
                                        </div>
                                        <router-link class="text-muted" to="/login">
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Go back to login
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-address">
                                <small class="text-muted mx-auto">
                                    18 St George's Place, Cheltenham, Gloucestershire. GL50 3JZ
                                    <br />
                                    T: 01242 571883 | E: office@owltherapycentre.co.uk
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import authService from '@api/auth';

    export default Vue.extend({
        data() {
            return {
                email: ''
            };
        },
        methods: {
            reset() {
                authService
                    .forgot(this.email)
                    .then(() => {
                        this.$toasted.success(
                            "If the provided email address matches an account on our system, you'll receive an email with the reset link shortly."
                        );

                        this.$router.push('/login');
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    });
            }
        },
        created() {
            window.document.title = `Forgot Password | ${window.app.title}`;
        }
    });
</script>
